(function () {

  'use strict';

  /*
   * =====================================================
   * LEBAY SMART SEARCH
   *
   * Shopify still performs the actual search.
   *
   * This layer removes broad/unrelated results by checking
   * the customer's terms against the actual product title.
   *
   * Examples:
   *
   * Nike
   * -> Nike products
   *
   * Nike Mind
   * -> Nike + Mind products
   *
   * Nike Mind 002
   * -> Nike + Mind + 002 products
   *
   * Nike Mind 002 Black
   * -> Nike + Mind + 002 + Black products
   *
   * Nke Mind 002 Blak
   * -> treated as Nike Mind 002 Black
   * =====================================================
   */


  var ALIASES = {

    /* Nike */
    'nke': 'nike',
    'ike': 'nike',
    'nkie': 'nike',
    'nikke': 'nike',

    /* Jordan */
    'jordon': 'jordan',
    'jrdon': 'jordan',
    'ordon': 'jordan',
    'jodan': 'jordan',

    /* Adidas */
    'addidas': 'adidas',
    'adiddas': 'adidas',
    'adias': 'adidas',
    'adids': 'adidas',

    /* Hoka */
    'hokka': 'hoka',
    'oka': 'hoka',

    /* Puma */
    'pumma': 'puma',
    'pma': 'puma',

    /* Colors */
    'blak': 'black',
    'balck': 'black',
    'blk': 'black',

    'wite': 'white',
    'whte': 'white',
    'wht': 'white',

    'gray': 'grey',
    'gry': 'grey',

    'blu': 'blue',

    'brwn': 'brown'

  };


  /*
   * Generic terms that shouldn't make a
   * product fail an otherwise good match.
   */

  var IGNORE_WORDS = {

    'shoe': true,
    'shoes': true,

    'sneaker': true,
    'sneakers': true,

    'pair': true,
    'pairs': true

  };


  var mutationTimer = null;


  /*
   * =====================================================
   * TEXT NORMALIZATION
   * =====================================================
   */

  function normalizeText(value) {

    value =
      String(value || '');


    /*
     * Remove accents where supported.
     */

    if (value.normalize) {

      value =
        value
          .normalize('NFD')
          .replace(
            /[\u0300-\u036f]/g,
            ''
          );

    }


    return value
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  }


  function canonicalToken(token) {

    token =
      normalizeText(token);


    if (ALIASES[token]) {

      return ALIASES[token];

    }


    return token;

  }


  function tokenize(value) {

    var normalized =
      normalizeText(value);


    if (!normalized) {

      return [];

    }


    var raw =
      normalized.split(' ');


    var output = [];


    raw.forEach(function (token) {

      token =
        canonicalToken(token);


      if (!token) {
        return;
      }


      if (IGNORE_WORDS[token]) {
        return;
      }


      /*
       * Avoid duplicate query terms.
       */

      if (
        output.indexOf(token) === -1
      ) {

        output.push(token);

      }

    });


    return output;

  }


  /*
   * =====================================================
   * REMOVE NITRO PRODUCT-TYPE QUERY PREFIX
   * =====================================================
   */

  function extractCustomerQuery(value) {

    value =
      String(value || '').trim();


    /*
     * Nitro can submit:
     *
     * product_type:Something AND Nike Mind
     *
     * We only need the customer's part.
     */

    if (
      /^product_type:/i.test(value) &&
      /\sAND\s/i.test(value)
    ) {

      var pieces =
        value.split(/\s+AND\s+/i);


      pieces.shift();


      value =
        pieces.join(' ');

    }


    /*
     * Defensive cleanup from any old
     * strict search URL.
     */

    value =
      value.replace(
        /^title:/i,
        ''
      );


    value =
      value.replace(
        /^"(.*)"$/,
        '$1'
      );


    return value.trim();

  }


  /*
   * =====================================================
   * LEVENSHTEIN TYPO DISTANCE
   * =====================================================
   */

  function editDistance(a, b) {

    if (a === b) {
      return 0;
    }


    if (!a.length) {
      return b.length;
    }


    if (!b.length) {
      return a.length;
    }


    var previous =
      new Array(
        b.length + 1
      );


    var current =
      new Array(
        b.length + 1
      );


    var i;
    var j;


    for (
      j = 0;
      j <= b.length;
      j++
    ) {

      previous[j] = j;

    }


    for (
      i = 1;
      i <= a.length;
      i++
    ) {

      current[0] = i;


      for (
        j = 1;
        j <= b.length;
        j++
      ) {

        var cost =
          a.charAt(i - 1) ===
          b.charAt(j - 1)
            ? 0
            : 1;


        current[j] =
          Math.min(

            current[j - 1] + 1,

            previous[j] + 1,

            previous[j - 1] + cost

          );

      }


      var swap =
        previous;

      previous =
        current;

      current =
        swap;

    }


    return previous[b.length];

  }


  /*
   * =====================================================
   * TOKEN MATCHING
   * =====================================================
   */

  function tokenMatches(
    queryToken,
    titleToken
  ) {

    queryToken =
      canonicalToken(
        queryToken
      );


    titleToken =
      canonicalToken(
        titleToken
      );


    /*
     * Exact match.
     */

    if (
      queryToken ===
      titleToken
    ) {

      return true;

    }


    /*
     * Model numbers should remain strict.
     *
     * 002 must match 002,
     * not 001 or 003.
     */

    if (
      /^\d+$/.test(
        queryToken
      )
    ) {

      return (
        queryToken ===
        titleToken
      );

    }


    /*
     * Partial typing.
     *
     * "bla" can match "black"
     * "min" can match "mind"
     */

    if (
      queryToken.length >= 2 &&
      titleToken.indexOf(
        queryToken
      ) === 0
    ) {

      return true;

    }


    /*
     * Don't fuzzy-match tiny words too
     * aggressively.
     */

    if (
      queryToken.length < 4
    ) {

      return false;

    }


    var lengthDifference =
      Math.abs(
        queryToken.length -
        titleToken.length
      );


    /*
     * Normal typo allowance.
     */

    var allowedDistance =
      queryToken.length >= 8
        ? 2
        : 1;


    if (
      lengthDifference >
      allowedDistance
    ) {

      return false;

    }


    return (
      editDistance(
        queryToken,
        titleToken
      ) <=
      allowedDistance
    );

  }


  /*
   * =====================================================
   * PRODUCT MATCHING
   *
   * ALL meaningful query terms must match.
   * =====================================================
   */

  function productMatches(
    productTitle,
    searchQuery
  ) {

    var queryTokens =
      tokenize(
        extractCustomerQuery(
          searchQuery
        )
      );


    if (!queryTokens.length) {

      return true;

    }


    var titleTokens =
      tokenize(
        productTitle
      );


    if (!titleTokens.length) {

      return false;

    }


    /*
     * Progressive narrowing:
     *
     * Nike
     * => Nike
     *
     * Nike Mind
     * => Nike AND Mind
     *
     * Nike Mind 002
     * => Nike AND Mind AND 002
     *
     * Nike Mind 002 Black
     * => all four must match.
     */

    return queryTokens.every(
      function (queryToken) {

        return titleTokens.some(
          function (titleToken) {

            return tokenMatches(
              queryToken,
              titleToken
            );

          }
        );

      }
    );

  }


  /*
   * =====================================================
   * PREDICTIVE SEARCH DRAWER
   * =====================================================
   */

  function updateDrawerCount(
    visibleCount
  ) {

    var viewAll =
      document.querySelector(
        '[data-viewAll-search] ' +
        '.bee-mini-search__viewAll'
      );


    if (!viewAll) {
      return;
    }


    /*
     * Preserve the SVG and replace only
     * the text-node count.
     */

    Array.prototype.forEach.call(
      viewAll.childNodes,
      function (node) {

        if (
          node.nodeType !== 3
        ) {
          return;
        }


        if (
          /\(\d+\)/.test(
            node.nodeValue
          )
        ) {

          node.nodeValue =
            node.nodeValue.replace(
              /\(\d+\)/,
              '(' +
              visibleCount +
              ')'
            );

        }

      }
    );

  }


  function getDrawerEmptyMessage(
    resultsContainer
  ) {

    var empty =
      resultsContainer.querySelector(
        '.lebay-smart-search-empty'
      );


    if (!empty) {

      empty =
        document.createElement(
          'span'
        );


      empty.className =
        'lebay-smart-search-empty';


      empty.textContent =
        'No closely matching products found.';


      resultsContainer.appendChild(
        empty
      );

    }


    return empty;

  }


  function filterPredictiveSearch() {

    var input =
      document.querySelector(
        '[data-input-search]'
      );


    var results =
      document.querySelector(
        '[data-results-search]'
      );


    if (
      !input ||
      !results
    ) {

      return;

    }


    var query =
      input.value.trim();


    var cards =
      results.querySelectorAll(
        '.bee-widget__pr'
      );


    /*
     * When the field is empty Nitro shows
     * suggestion products. Don't touch them.
     */

    if (
      query.length < 2
    ) {

      Array.prototype.forEach.call(
        cards,
        function (card) {

          card.classList.remove(
            'lebay-smart-hidden'
          );

        }
      );


      var oldEmpty =
        results.querySelector(
          '.lebay-smart-search-empty'
        );


      if (oldEmpty) {
        oldEmpty.style.display =
          'none';
      }


      return;

    }


    var visibleCount = 0;


    Array.prototype.forEach.call(
      cards,
      function (card) {

        var title =
          card.querySelector(
            '.bee-widget__pr-title'
          );


        var matches =
          title &&
          productMatches(
            title.textContent,
            query
          );


        card.classList.toggle(
          'lebay-smart-hidden',
          !matches
        );


        if (matches) {

          visibleCount++;

        }

      }
    );


    var empty =
      getDrawerEmptyMessage(
        results
      );


    empty.style.display =
      visibleCount === 0
        ? ''
        : 'none';


    updateDrawerCount(
      visibleCount
    );

  }


  /*
   * =====================================================
   * FULL SEARCH RESULTS PAGE
   * =====================================================
   */

  function currentPageQuery() {

    try {

      var url =
        new URL(
          window.location.href
        );


      return (
        url.searchParams.get('q') ||
        ''
      );

    } catch (error) {

      return '';

    }

  }


  function updateSearchPageCount(
    count
  ) {

    var counters =
      document.querySelectorAll(
        '.bee-search-page ' +
        '.bee-active-filters__count'
      );


    Array.prototype.forEach.call(
      counters,
      function (element) {

        element.textContent =
          element.textContent.replace(
            /\d+/,
            String(count)
          );

      }
    );

  }

  /*
 * =====================================================
 * SEARCH PAGE MAIN HEADING COUNT
 * =====================================================
 */

function updateSearchPageHeading(
  count,
  query
) {

  var heading =
    document.querySelector(
      '.bee-page-head .bee-title-head'
    );


  if (!heading) {
    return;
  }


  var currentText =
    heading.textContent || '';


  /*
   * Nitro outputs something like:
   *
   * 113 Search Results for: “Nike mind”
   *
   * Replace only the first number so the
   * existing wording/font/translation stays intact.
   */

  if (
    /^\s*\d+/.test(
      currentText
    )
  ) {

    heading.textContent =
      currentText.replace(
        /^\s*\d+/,
        String(count)
      );

    return;
  }


  /*
   * Fallback in case Nitro's wording changes.
   */

  heading.textContent =
    count +
    ' Search Results for: “' +
    query +
    '”';

}

  function getPageEmptyMessage(
    page
  ) {

    var empty =
      page.querySelector(
        '.lebay-smart-page-empty'
      );


    if (!empty) {

      empty =
        document.createElement(
          'div'
        );


      empty.className =
        'lebay-smart-page-empty';


      empty.innerHTML =
        '<strong>No closely matching products found.</strong>' +
        '<span>Try a shorter product or model name.</span>';


      var firstGrid =
        page.querySelector(
          '.bee-products'
        );


      if (firstGrid) {

        firstGrid.insertAdjacentElement(
          'afterend',
          empty
        );

      }

    }


    return empty;

  }


  function filterSearchPage() {

    var page =
      document.querySelector(
        '.bee-search-page'
      );


    if (!page) {
      return;
    }


    var query =
      currentPageQuery();


    if (!query) {
      return;
    }


    query =
      extractCustomerQuery(
        query
      );


    var grids =
      page.querySelectorAll(
        '.bee-products:not(.bee-suggest-products)'
      );


    var totalVisible = 0;
    var totalCards = 0;


    Array.prototype.forEach.call(
      grids,
      function (grid) {

        var cards =
          grid.querySelectorAll(
            '.bee-product'
          );


        Array.prototype.forEach.call(
          cards,
          function (card) {

            totalCards++;


            var title =
              card.querySelector(
                '.bee-product-title'
              );


            var matches =
              title &&
              productMatches(
                title.textContent,
                query
              );


            card.classList.toggle(
              'lebay-smart-hidden',
              !matches
            );


            if (matches) {

              totalVisible++;

            }

          }
        );

      }
    );


    if (!totalCards) {
      return;
    }


    updateSearchPageCount(
      totalVisible
    );

    updateSearchPageHeading(
  totalVisible,
  query
);

    var empty =
      getPageEmptyMessage(
        page
      );


    if (empty) {

      empty.style.display =
        totalVisible === 0
          ? 'flex'
          : 'none';

    }
/*
 * Smart filtering is complete.
 * Now reveal the final results.
 */

document.documentElement.classList.remove(
  'lebay-smart-search-pending'
);


document.documentElement.classList.add(
  'lebay-smart-search-ready'
);
  }


  /*
   * =====================================================
   * RUN SMART SEARCH
   * =====================================================
   */

  function runSmartSearch() {

    filterPredictiveSearch();
    filterSearchPage();

  }


  /*
   * Customer typing.
   */

  document.addEventListener(
    'input',
    function (event) {

      if (
        event.target &&
        event.target.matches(
          '[data-input-search]'
        )
      ) {

        clearTimeout(
          mutationTimer
        );


        mutationTimer =
          setTimeout(
            runSmartSearch,
            120
          );

      }

    }
  );


  /*
   * Nitro replaces search HTML with AJAX.
   * Watch for those replacements and
   * reapply our relevance filter.
   */

  var observer =
    new MutationObserver(
      function () {

        clearTimeout(
          mutationTimer
        );


        mutationTimer =
          setTimeout(
            runSmartSearch,
            80
          );

      }
    );


  function initialize() {

    runSmartSearch();


    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );

  } else {

    initialize();

  }

})();